export default __webpack_public_path__ + "static/media/favs.2f79613a.png";